import type { AssistantImage } from '../types/chat';

const STORAGE_KEY = 'skf.assistant.images';

type ImageMap = Record<string, AssistantImage>;

export function saveAssistantImage(image: AssistantImage): void {
    if (!isStorageAvailable() || !image?.id) {
        return;
    }

    const map = readCache();
    map[image.id] = image;
    writeCache(map);
}

export function getAssistantImage(imageId: string | undefined): AssistantImage | null {
    if (!imageId || !isStorageAvailable()) {
        return null;
    }

    const map = readCache();
    return map[imageId] ?? null;
}

export function clearAssistantImageCache(): void {
    if (!isStorageAvailable()) {
        return;
    }

    window.localStorage.removeItem(STORAGE_KEY);
}

function readCache(): ImageMap {
    if (!isStorageAvailable()) {
        return {};
    }

    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
        return {};
    }

    try {
        const parsed = JSON.parse(raw) as ImageMap;
        return parsed && typeof parsed === 'object' ? parsed : {};
    }
    catch {
        return {};
    }
}

function writeCache(map: ImageMap): void {
    if (!isStorageAvailable()) {
        return;
    }

    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    }
    catch {
        // ignore storage quota issues
    }
}

function isStorageAvailable(): boolean {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}
